<div class="decathlon-import">
  <h2>Decathlon Permit Import</h2>

  <div class="upload-panel">
    <p>Upload a Decathlon CSV or XLSX file to create or update parking permits.</p>

    <div class="form-row">
      <input type="file" accept=".csv,.xlsx" (change)="onFileSelected($event)" />
    </div>

    <label class="form-row">
      <input type="checkbox" [(ngModel)]="removeMissingPermits" />
      End permits that are missing from this import
    </label>

    <button type="button" class="btn btn-primary" [disabled]="processing || !selectedFile" (click)="upload()">
      {{ processing ? 'Uploading...' : 'Upload Import' }}
    </button>
  </div>

  <div *ngIf="result" class="summary-panel">
    <h3>Import Summary</h3>
    <div class="summary-grid">
      <div><strong>Processed</strong><span>{{ result.ProcessedCount }}</span></div>
      <div><strong>Successful</strong><span>{{ result.SuccessCount }}</span></div>
      <div><strong>Failed</strong><span>{{ result.FailureCount }}</span></div>
      <div><strong>Skipped</strong><span>{{ result.SkippedCount }}</span></div>
      <div><strong>Created</strong><span>{{ result.CreatedCount }}</span></div>
      <div><strong>Updated</strong><span>{{ result.UpdatedCount }}</span></div>
      <div><strong>Ended</strong><span>{{ result.EndedCount }}</span></div>
      <div><strong>Users Created</strong><span>{{ result.UserCreatedCount }}</span></div>
    </div>

    <h3>Rows Requiring Attention</h3>
    <table class="table table-striped" *ngIf="result.Rows?.length">
      <thead>
        <tr>
          <th>Row</th>
          <th>Badge ID</th>
          <th>Status</th>
          <th>Action</th>
          <th>Gate</th>
          <th>Parking Lot</th>
          <th>Permit Type</th>
          <th>End Date</th>
          <th>Message</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let row of result.Rows">
          <td>{{ row.RowNumber }}</td>
          <td>{{ row.BadgeId }}</td>
          <td>{{ rowStatus(row) }}</td>
          <td>{{ row.Action }}</td>
          <td>{{ row.GateName }}</td>
          <td>{{ row.ParkingLotName }}</td>
          <td>{{ row.ParkingPermitTypeName }}</td>
          <td>{{ row.PermitEndDate | date:'shortDate' }}</td>
          <td>{{ row.ErrorMessage }}</td>
        </tr>
      </tbody>
    </table>
    <p *ngIf="!result.Rows?.length">No failures or changed rows to report.</p>
  </div>
</div>
